import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-delete",
  templateUrl: "./med-icon-delete.component.html",
})
export class MedIconDeleteComponent extends SvgMixinComponent {}
